module.exports = __webpack_public_path__ + "static/media/feedback2.16aea3d2.png";